import packageConfig from '../../package.json';

export const cdnPath = 'https://utils-cdn.petsure.com.au';

export const BuildSettings = {
  // cba: {
  //   public: {
  //     gtmTagId: '',
  //     analytics: {
  //       google: {
  //         sit: {
  //           disabled: true
  //         },
  //         uat: {
  //           disabled: true
  //         },
  //         preprod: {
  //           disabled: true
  //         },
  //         prod: {
  //           disabled: true
  //         }
  //       }
  //     }
  //   }
  // },
  // medibank: {
  //   public: {
  //     gtmTagId: '',
  //     analytics: {
  //       google: {
  //         sit: {
  //           disabled: true
  //         },
  //         uat: {
  //           disabled: true
  //         },
  //         preprod: {
  //           disabled: true
  //         },
  //         prod: {
  //           disabled: true
  //         }
  //       }
  //     }
  //   }
  // },
  // bupa: {
  //   public: {
  //     gtmTagId: '',
  //     analytics: {
  //       google: {
  //         sit: {
  //           disabled: true
  //         },
  //         uat: {
  //           disabled: true
  //         },
  //         preprod: {
  //           disabled: true
  //         },
  //         prod: {
  //           disabled: true
  //         }
  //       }
  //     }
  //   }
  // },
  pia: {
    public: {
      gtmTagId: '',
      analytics: {
        google: {
          sit: {
            disabled: true
          },
          uat: {
            disabled: true
          },
          preprod: {
            disabled: true
          },
          prod: {
            disabled: true
          }
        }
      }
    }
  },
  edi: {
    public: {
      gtmTagId: '',
      analytics: {
        google: {
          sit: {
            disabled: true
          },
          uat: {
            disabled: true
          },
          preprod: {
            disabled: true
          },
          prod: {
            disabled: true
          }
        }
      }
    }
  },
  buddy: {
    public: {
      gtmTagId: '',
      analytics: {
        google: {
          sit: {
            disabled: true
          },
          uat: {
            disabled: true
          },
          preprod: {
            disabled: true
          },
          prod: {
            disabled: true
          }
        }
      }
    }
  },
  bupa: {
    public: {
      gtmTagId: '',
      analytics: {
        google: {
          sit: {
            disabled: true
          },
          uat: {
            disabled: true
          },
          preprod: {
            disabled: true
          },
          prod: {
            disabled: true
          }
        }
      }
    }
  },
  trupanion: {
    public: {
      gtmTagId: '',
      analytics: {
        google: {
          sit: {
            disabled: true
          },
          uat: {
            disabled: true
          },
          preprod: {
            disabled: true
          },
          prod: {
            disabled: true
          }
        }
      }
    }
  },
  hcf: {
    public: {
      gtmTagId: '',
      analytics: {
        google: {
          sit: {
            disabled: true
          },
          uat: {
            disabled: true
          },
          preprod: {
            disabled: true
          },
          prod: {
            disabled: true
          }
        }
      }
    }
  },
  bwm: {
    public: {
      gtmTagId: '',
      analytics: {
        google: {
          sit: {
            disabled: true
          },
          uat: {
            disabled: true
          },
          preprod: {
            disabled: true
          },
          prod: {
            disabled: true
          }
        }
      }
    }
  },
  pinscom: {
    public: {
      gtmTagId: '',
      analytics: {
        google: {
          sit: {
            disabled: true
          },
          uat: {
            disabled: true
          },
          preprod: {
            disabled: true
          },
          prod: {
            disabled: true
          }
        }
      }
    }
  },
  real: {
    public: {
      gtmTagId: '',
      analytics: {
        google: {
          sit: {
            disabled: true
          },
          uat: {
            disabled: true
          },
          preprod: {
            disabled: true
          },
          prod: {
            disabled: true
          }
        }
      }
    }
  }
};

export const GetBrandLibraryVersion = (brand, site) => {
  if (BuildSettings[brand][site] && BuildSettings[brand][site].libraryVersion) {
    return BuildSettings[brand][site].libraryVersion;
  }
  const UILibraryDependency = packageConfig.dependencies['@PetSureAustralia/petsure-react-ui-library'];
  const VersionRegex = /([0-9.]+)/;
  const UILibraryVersion = UILibraryDependency.match(VersionRegex);

  if (UILibraryVersion) {
    return UILibraryVersion[0];
  }

  return new Error('Could not determine ui library version');
};

export const GetBrandBuildSettings = ({ brand, site, buildDirectory }) => {
  const entryKey = `${brand}_${site}`;
  const outputPath = `${buildDirectory}/brands/${brand}/${site}/`;
  const libraryVersion = GetBrandLibraryVersion(brand, site);
  const cssFilePath = `${cdnPath}/${libraryVersion}/brandCssFiles`;
  const { gtmTagId, analytics } = BuildSettings[brand][site];

  return {
    entryKey,
    outputPath,
    libraryVersion,
    cdnPath,
    cssFilePath,
    gtmTagId,
    analytics
  };
};
